import React from "react";
import { dateFromString } from "../../../utils/dateFromString";
import { Tooltip } from "antd";
import { CloudUploadOutlined } from "@ant-design/icons";
import { ModalCargarFactura } from "./_ModalCargarFactura";
import { MotivoRechazo } from "./_MotivoRechazo";

export const Factura = ({ orden }) => {
  const [open, setOpen] = React.useState(false);

  if (orden.estatusOrdenPagoID === 3)
    return (
      <div>
        <Tooltip title="Cargar Factura">
          <CloudUploadOutlined
            onClick={() => setOpen(true)}
            className="eyeIcon"
            style={{ fontSize: 20, color: "blue" }}
          />
        </Tooltip>
        <MotivoRechazo motivo={orden.facturaMotivoRechazo} />
        <ModalCargarFactura open={open} setOpen={setOpen} orden={orden} />
      </div>
    );

  if (orden.fechaCargaFactura)
    return (
      <div>
        {dateFromString(orden.fechaCargaFactura).soloFecha}
      </div>
    );

  return <div></div>;
};
